export default __webpack_public_path__ + "static/media/Aspfang.67ff954c.jpg";